// rxjs-extension/reactives/number.ts
import { BehaviorSubject } from "rxjs";
var NumberBehaviorSubject = class extends BehaviorSubject {
  constructor(value) {
    if (isNaN(+value))
      throw new Error("NumberBehaviorSubject only accepts numbers (or strings convertible to numbers)");
    super(+value);
  }
  next(value) {
    if (isNaN(+value))
      throw new Error("NumberBehaviorSubject only accepts numbers (or strings convertible to numbers)");
    super.next(+value);
  }
};
export {
  NumberBehaviorSubject
};
